import React from 'react';
import {render} from 'react-dom';

import NearestMatches from '../modules/ti-2021/nearest-matches';
import PlayoffBracketActive from '../modules/ti-2021/playoff-bracket-active';
import StreamVideo from '../modules/ti-2021/stream-video';

render(<StreamVideo />, document.querySelector('.js-widget-stream'));
render(<NearestMatches />, document.querySelector('.js-widget-nearest-matches'));
render(<PlayoffBracketActive />, document.querySelector('.js-widget-bracket'));
